import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/esm/objectWithoutPropertiesLoose';
import { forwardRef, useRef, useLayoutEffect, createElement } from 'react';
import { Box3, Vector3 } from 'three';

const Center = /*#__PURE__*/forwardRef(function Center(_ref, ref) {
  let {
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  const outer = useRef();
  const inner = useRef();
  useLayoutEffect(() => {
    if (inner.current && outer.current) {
      const box = new Box3();
      box.setFromObject(inner.current);
      const center = new Vector3();
      box.getSize(center);
      outer.current.position.set(-center.x / 2, -center.y / 2, -center.z / 2);
    }
  }, [children]);
  return /*#__PURE__*/createElement("group", _extends({
    ref: ref
  }, props), /*#__PURE__*/createElement("group", {
    ref: outer
  }, /*#__PURE__*/createElement("group", {
    ref: inner
  }, children)));
});

export { Center };
